import {h, Component, Fragment} from 'preact';
import {route} from "preact-router";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import LFeed from "../../../services/live-feed";
import Ticket from "../utils/ticket-logic.jsx";

import * as M from "../desktop-templates/prematch-menu.jsx";
import * as P from "../desktop-templates/prematch-tournament.jsx";
import AwrabetPrematchLiveEvents, {
    PrematchLiveEventsContent as AwrabetPrematchLiveEventsContent,
    LiveEventOdds as AwrabetLiveEventOdds
} from '../../awrabet/desktop-components/prematch-live-events.jsx';

export default class PrematchLiveEvents extends AwrabetPrematchLiveEvents {
	render() {
		if (!LFeed.menu)
			return;
		const sport = this.bestSport(LFeed.menu);
		return <PrematchLiveEventsContent defaultSport={sport.id} />
	}
}

export class PrematchLiveEventsContent extends AwrabetPrematchLiveEventsContent {
	render() {
		return <div>
		  <P.CardHeaderRow>
			<P.ThreeDots />
			<P.CardHeaderTitle><Trans>Main Live Events</Trans></P.CardHeaderTitle>
			<P.CardHeaderSports>
			  {this.bestFourSports(LFeed.menu).map(sport => (
				<P.SportNameButton onClick={() => this.setCurrentSport(sport.id)} active={this.isCurrentSport(sport.id)}>
				  <M.SportFlagIcon sport={sport} /> {sport.name}
				</P.SportNameButton>
			  ))}
			</P.CardHeaderSports>
		  </P.CardHeaderRow>
		  <P.OddsTableHeadRow>
			<P.HeadRowCellId><Trans>Time</Trans></P.HeadRowCellId>
			<P.HeadRowCellTime><Trans>Set</Trans></P.HeadRowCellTime>
			<P.HeadRowCellTime><Trans>Score</Trans></P.HeadRowCellTime>
			<P.HeadRowCellEvent><Trans>Event</Trans></P.HeadRowCellEvent>
			<P.OddsWidthContainer>
			  {this.preferredMarkets[this.getCurrentSportId()].outcomes == 3 ? <Fragment>
			    <P.HeadOddCell><Trans>1</Trans></P.HeadOddCell>
			    <P.HeadOddCell><Trans>X</Trans></P.HeadOddCell>
			    <P.HeadOddCell><Trans>2</Trans></P.HeadOddCell>
			  </Fragment>
			  : <Fragment>
			    <P.HeadOddCell><Trans>1</Trans></P.HeadOddCell>
			    <P.HeadOddCell><Trans>2</Trans></P.HeadOddCell>
			  </Fragment>}
			  <P.HeadMoreCell />
			</P.OddsWidthContainer>
		  </P.OddsTableHeadRow>
		  {this.getSomeEvents().map(event => <div>
			  <P.EventRow>
				<P.HeadRowCellId onClick={e => route('/live'+event.id)}><span class="truncate">{event.status.timer ? event.status.timer+"'" : ''}</span></P.HeadRowCellId>
				<P.HeadRowCellTime onClick={e => route('/live'+event.id)}><span class="text-xxs">{event.status.phase}</span></P.HeadRowCellTime>
				<P.HeadRowCellTime onClick={e => route('/live'+event.id)}><span class="font-bold text-amber-500">{event.current.result.join(' - ')}</span></P.HeadRowCellTime>
				<P.ContentRowCellEvent onClick={e => route('/live'+event.id)}>{event.home}{event.away ? ' - '+event.away : ''}</P.ContentRowCellEvent>
				<P.OddsWidthContainer>
				  <LiveEventOdds market={this.preferredMarketForEvent(event)} />
				  <P.MoreButton onClick={e => route('/live'+event.id)}>+</P.MoreButton>
				</P.OddsWidthContainer>
			  </P.EventRow>
		  </div>)}
		  <P.ShowMoreFooter onClick={e => route('/live/'+this.getCurrentSportId().split('/')[2])}><Trans>Show More</Trans> {'>>'}</P.ShowMoreFooter>
		</div>
	}
}

export class LiveEventOdds extends AwrabetLiveEventOdds {
	render({market}) {
		return !!market
		? Object.values(market.sub).map(outcome => (
			<P.EventOddButton
				value={outcome && outcome.value}
				selected={outcome && Ticket.hasLiveOdds(outcome.id)}
				onClick={() => Ticket.toggleLiveOdds(outcome.id)} />
		))
		: <P.OddsWidthEmpty />
	}
}